export const LIST_VIEW_MODE_PARAM = 'view'

export type ListCardsCalendarViewMode = 'list' | 'cards' | 'calendar'
export type ListCardsViewMode = 'list' | 'cards'

export function parseViewModeParam<T extends string>(
  value: string | null | undefined,
  allowed: readonly T[],
  fallback: T,
): T {
  const normalized = String(value ?? '').trim().toLowerCase()
  if (allowed.includes(normalized as T)) {
    return normalized as T
  }
  return fallback
}

export function readStoredViewMode<T extends string>(
  storageKey: string,
  allowed: readonly T[],
  fallback: T,
): T {
  try {
    const stored = localStorage.getItem(storageKey)
    if (stored && allowed.includes(stored as T)) {
      return stored as T
    }
  } catch {
    // Ignore storage failures.
  }
  return fallback
}

export function resolveViewModeFromLocation<T extends string>(
  search: string,
  storageKey: string,
  allowed: readonly T[],
  defaultMode: T,
): T {
  const fromUrl = new URLSearchParams(search).get(LIST_VIEW_MODE_PARAM)
  if (fromUrl) {
    return parseViewModeParam(fromUrl, allowed, defaultMode)
  }
  return readStoredViewMode(storageKey, allowed, defaultMode)
}

export function syncViewModeSearchParam(
  params: URLSearchParams,
  mode: string,
  defaultMode: string,
): void {
  if (mode === defaultMode) {
    params.delete(LIST_VIEW_MODE_PARAM)
  } else {
    params.set(LIST_VIEW_MODE_PARAM, mode)
  }
}
